type Tag = {
  created_at: string | null;
  description: 'string';
  id: number;
  name: string;
  search_enabled: 1 | 0;
  slug: string;
  updated_at: string | null;
};

// Sort and array of tag from oldest to newest
function sortTagsByDate(tagA: Tag, tagB: Tag): 1 | -1 {
  const tagADate = tagA.created_at ? new Date(tagA.created_at).getTime() : null;
  const tagBDate = tagB.created_at ? new Date(tagB.created_at).getTime() : null;

  // Consider the one without a date to be older
  if (tagADate === null && tagBDate !== null) {
    return -1;
  }
  if (tagADate !== null && tagBDate === null) {
    return 1;
  }

  // If both dates are null, or if both dates are present and equal,
  // use a secondary sort key to ensure consistent order.
  if (tagADate === tagBDate) {
    if (tagA.id < tagB.id) return -1;
    if (tagA.id > tagB.id) return 1;
    return -1;
  }

  // If both dates are present, sort oldest to newest
  if (tagADate! < tagBDate!) {
    return -1;
  }

  return 1;
}

export { sortTagsByDate };
